
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/learn-spoken-english",
      function () {
        return require("private-next-pages/school/learn-spoken-english.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/learn-spoken-english"])
      });
    }
  